import type { FC } from 'react';
import cx from 'classnames';

type ListRowContainerProps = {
  isDisabled?: boolean;
};

/**
 * A component responsible for the positioning and separation of items in a
 * `List`.
 */
const ListRowContainer : FC<ListRowContainerProps> = ({ isDisabled, children }) => {
  return (
    <div className={cx('fossa-list__row-container', {
      'fossa-list__row-container--disabled': isDisabled,
    })}>
      {children}
    </div>
  );
};

export default ListRowContainer;
